<template>
    <div class="footer-inner">
      <div class="left">
        Imprint: Yue-Shin Lin + Dennis Helbig<br />
        <a class="" target="_blank" href="https://www.google.at/maps/place/Sigmundstadl+1,+8020+Graz/">Sigmundstadl 1</a>, 8020 Graz<span class="desktop">, </span><br class="mobile"/><a href="mailto:mail@onimo-studios.com">mail@onimo-studios.com</a> 
      </div>
      <div class="right">
        <router-link v-if="privacy" :to="{name: 'home', params: { linkClick: true }}">[X] CLOSE</router-link>
         <router-link v-else :to="{name: 'privacy', params: { linkClick: true }}">Data Protection</router-link>
        </div>
    </div>
</template>

<script>

export default {
  computed: {
    privacy(){
      return this.$route.name === 'privacy';
    }
  }
}
</script>


<style type="text/css" lang="scss" scoped>
  .footer-inner{
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: flex-end;
    padding: 15px;
    padding-top: 45px;
    text-transform: uppercase;
  }

  br.mobile{
    display: none;
    @media( $max768 ){
      display: inline;
    }
  }
  span.desktop{
    @media( $max768 ){
      display: none;
    }
  }

  @media( $max560 ){
    .footer-inner{
      flex-direction: column; 
      justify-content: flex-start;
    }
    
    .left,.right{
      width: 100%;
    }
    .left{
      margin-bottom: 2em;
    }
  }

  a{
    z-index: 2;
    position: relative;
    color: white;
    @include underline();

    &:after{
      z-index: -1;
      background: rgba($color: white, $alpha: 0.9);
    }

    &:hover{
      color: black;
    }
  }
</style>